<template>
    <page>
        <module title="系统配置">
            <c-form ref="form">
                <c-form-item type="input" label="七鱼客服组ID" name="QIYUKF_USER_ID"   ></c-form-item>
                <c-form-item type="input" label="账户提现手续费率" name="WITHDRAWAL_RATE"   word="%"></c-form-item>
                <c-form-item type="number"label="账户单次提现上限" name="A_SINGLE_WITHDRAWAL_LIMIT"  ></c-form-item>
                <c-form-item type="radio" label="退货退款需要后台审批"   :options="switchOptions"  name="RETURN_ORDER_CHECK_ENABLED" ></c-form-item>
                <c-form-item type="radio" label="订单是否可以开票"   :options="switchOptions"  name="ORDER_INVOICE_ENABLED" ></c-form-item>
                <c-form-item type="radio" label="订单是否需要审核"   :options="switchOptions"  name="ORDER_CHECK_ENABLED" ></c-form-item>
                <c-form-item type="radio" label="订单是否需要推送三方平台"   :options="switchOptions"  name="ORDER_PUSH_ENABLED" ></c-form-item>
                <!--
				<c-form-item type="radio" label="登录验证码"  name="OMS_LOGIN_VERIFY_SWITCH"  :options="switchOptions" ></c-form-item>
				<c-form-item type="input" label="平台发货地址" name="SHIPPING_ADDRESS"   ></c-form-item>
                <c-form-item type="radio" label="出账方式"   :options="payPeriodType"  name="PAY_PERIOD_TYPE" ></c-form-item>
                <c-form-item type="input" label="出账后还款天数" name="PAY_PERIOD_VALUE"   ></c-form-item>
                <c-form-item type="input" label="客服电话" name="CUSTOMER_SERVICE_PHONE"   ></c-form-item>
                <c-form-item type="input" label="联系邮箱" name="CUSTOMER_SERVICE_EMAIL"   ></c-form-item>
				-->
                <c-form-item type="input" label="出账后还款天数" name="PAY_PERIOD_VALUE"   ></c-form-item>
                <c-form-item type="number" decimal="1" label="超期未支付自动关闭" name="ORDER_AUTO_CLOSE_TIME"  :limit="[0.5,100]" word="小时"></c-form-item>
            </c-form>

            <template slot="button">
                <c-button size="m" power="b_platform_config_save" @click="save()">保存</c-button>
            </template>
        </module>

    </page>
</template>

<script>

    export default {
        name: 'm_platform_config',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
                fromData:{
                },
                switchOptions: [{
                    name: '开',
                    value: 'ON'
                }, {
                    name: '关',
                    value: 'OFF'
                }],
                payPeriodType:[{
                    name: '发货后',
                    value: '1'
                }, {
                    name: '开票后',
                    value: '2'
                }],
            }
        },

        watch: {

        },

        mounted() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/platform_config/list',
                    data: {
                        config_group: ""
                    },
                    loading: true,
                    success: data => {
                        let json = {};
                        data.forEach(function (item,i){
                            json[item.config_item_code] = item.config_item_value;
                        });
                        this.$refs.form.set(json);

                    }
                });
            },


            save() {
                this.$refs.form.submit({
                    url: '/platform_config/edit',
                    dataFormatter: data => {
                        let arr = [];
                        for (let key in data) {
                            arr.push({
                                config_item_code: key,
                                config_item_value: data[key] ? data[key].toString() : ''
                            });
                        }
                        return {
                            platform_config_list: arr
                        };
                    },
                    success: () => {
                        this.$message({
                            text: '操作成功'
                        });

                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .box {
    padding: 15px;
    background: #f9f8fb;
  }

  .product {
    position: relative;
    width: 90px;
    height: 90px;
    border: 1px solid #DDDDDD;
    margin-right: 15px;
    margin-top: 15px;
    background: #fff;
    box-sizing: border-box;

    video {
      width: 100%;
      height: 100%;
      background: #000;
    }

    a {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 18px;
      height: 18px;
      font-size: 12px;
      color: #fff;
      background: #FF1010;
    }

    &-list {
      margin-top: -15px;
    }

    &-add {
      font-size: 20px;
      color: #ccc;
      cursor: pointer;
      transition: all .3s ease;

      &:hover {
        border-color: #bbb;
        color: #bbb;
      }
    }
  }
</style>